import MobileHeader from "./Header/DemoHeader/DemoHeaderMobile";
import FooterFour from "./Footer/FooterFour";
import DemoHeaderFour from "../Layout/Header/DemoHeader/DemoHeaderFour";
import ParticlesBackground from "../ParticlesBackground";

export default function InnerPageLayout({ children }) {
  return (
    <div className="bg-[#0a0118] w-full overflow-x-hidden">
      <MobileHeader />
      <DemoHeaderFour />
      {/* Particle wrapper */}
      <div className="relative z-0">
        {/* Background layer */}
        <ParticlesBackground />
        {/* Foreground content */}
        <div className="relative z-10">{children}</div>
      </div>
      <FooterFour />
    </div>
  );
}
